/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type SubStageEntityTypeEnum = "containers" | "shipments" | "%future added value";
export type infoChangeEntitySubStageInput = {
    clientMutationId?: string | null;
    entityType: SubStageEntityTypeEnum;
    entitySlug: string;
    stage?: string | null;
    subStage: string;
};
export type SubStageChangeMutationVariables = {
    input: infoChangeEntitySubStageInput;
};
export type SubStageChangeMutationResponse = {
    readonly infoChangeEntitySubStage: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SubStageChangeMutation = {
    readonly response: SubStageChangeMutationResponse;
    readonly variables: SubStageChangeMutationVariables;
};



/*
mutation SubStageChangeMutation(
  $input: infoChangeEntitySubStageInput!
) {
  infoChangeEntitySubStage(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoChangeEntitySubStagePayload",
    "kind": "LinkedField",
    "name": "infoChangeEntitySubStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SubStageChangeMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SubStageChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8d9e203d3936bb05d431adba1b65b9ef",
    "id": null,
    "metadata": {},
    "name": "SubStageChangeMutation",
    "operationKind": "mutation",
    "text": "mutation SubStageChangeMutation(\n  $input: infoChangeEntitySubStageInput!\n) {\n  infoChangeEntitySubStage(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '99762ca2e4bd76f578abc25733cb6019';
export default node;
